import {LitElement} from "lit-element";
import { connect } from "pwa-helpers";
import { StofwarePageElement } from "@stofloos/core/base/sw-page-element";
import { store } from "@stofloos/stores/store";
import { initRequest, setPageLimit, setQueryFilter, setOrderBy } from "@stofloos/actions/requests";
import {
	createObject,
	deleteObject,
	readObject,
	readObjects,
	updateObject,
	unsetObject,
	setObject
} from "@stofloos/actions/crud";
import { formToJSON, getFormElements } from "@stofloos/utils/sw-constants";
import { showToast } from "@stofloos/actions/toast";
import { localize } from "@stofloos/actions/localize";
import { closeDialog } from "@stofloos/actions/dialog";

export class StofwarePageCrud extends connect(store)(LitElement) {
	static get properties() {
		return {
			id: Number,
			requestId: String,
			singleRequestId: String,
			pageName: String,
			page: Number,
			pageLimit: {type: Number},
			totalObjects: {type: Number},
			totalPages: Number,
			hasMorePages: {type: Boolean},
			isFetching: {type: Boolean},
			active: {type: Boolean},
			objects: {type: Array},
			object: {type: Object},
			filters: {type: Array},
			endpoint: String,
			orderBy: String,
			orderDirection: String,
			meta: Object
		};
	}

	constructor() {
		super();
		this.pageLimit = 10;
		this.objects = null
	}

	stateChanged(state) {
		if (state.crud[this.requestId] && state.app && (state.app.page === this.endpoint || this.pageName === this.endpoint)) {
			this.objects = state.crud[this.requestId];
		}

		if (state.crud[this.requestId]) {
			this.page = state.requests[this.requestId].page;
			this.totalPages = state.requests[this.requestId].totalPages;
			this.totalObjects = state.requests[this.requestId].totalObjects;
			this.hasMorePages = state.requests[this.requestId].hasMorePages;
			this.isFetching = state.requests[this.requestId].isFetching;
		}
	}

	updated(_changedProperties) {
		const objects = store.getState().crud[this.requestId];
		if(_changedProperties.has('active') && this.active
			&& ( !objects ||
				objects && objects.length < this.pageLimit )) {
			store.dispatch(readObjects(this.requestId));
		}
	}

	firstUpdated(_changedProperties) {
		super.firstUpdated(_changedProperties);

		this.requestId = this.endpoint;
		this.singleRequestId = this.endpoint;

		if(!store.getState().requests[this.requestId]){
			store.dispatch(initRequest(this.requestId, this.endpoint));
			store.dispatch(setPageLimit(this.requestId, this.pageLimit));
			if(this.orderDirection && this.orderBy){
				store.dispatch(setOrderBy(this.requestId, this.orderBy, this.orderDirection));
			}
			store.dispatch(setQueryFilter(this.requestId, "deleted", "eq", false));
			if (this.filters && this.filters.length) {
				this.filters.forEach(filter => {
					store.dispatch(setQueryFilter(this.requestId, filter.name, filter.operator, filter.value));
				});
			}
		}
		if(!store.getState().requests[this.singleRequestId]){
			store.dispatch(initRequest(this.singleRequestId, this.endpoint));
		}
	}

	createObject() {
		let formElements = getFormElements(this.shadowRoot.querySelector("sw-form"));
		let data = formToJSON(formElements);
		store.dispatch(createObject(this.singleRequestId, data));

		store.dispatch(showToast(localize(this.endpoint) + " " + localize("main::created")));
		store.dispatch(closeDialog("createObjectDialog"));
	}

	readObject() {
		store.dispatch(readObject(this.singleRequestId, this.object.id));
	}

	updateObject() {
		let formElements = getFormElements(this.shadowRoot.querySelector("sw-form"));
		let data = formToJSON(formElements);
		store.dispatch(updateObject(this.singleRequestId, data));
		store.dispatch(showToast(localize(this.endpoint) + " " + localize("main::updated")));
		store.dispatch(closeDialog("editObjectDialog"));
	}

	deleteObject(id) {
		let objectId;
		if (id) {
			objectId = id;
		} else {
			objectId = this.object.id;
		}

		store.dispatch(deleteObject(this.singleRequestId, objectId));
		store.dispatch(unsetObject(this.requestId, objectId));

		store.dispatch(showToast(localize(this.endpoint) + " " + localize("main::deleted")));
		store.dispatch(closeDialog("deleteObjectDialog"));
		store.dispatch(closeDialog("editObjectDialog"));
	}
}
